<template>
  <div class="transactions-sort-by-currency-from">
    <p class="transactions-sort-by-currency-from__title">
      {{ $t('transactions.debiting_currencies') }}
    </p>
    <AtSelect
        v-if="hasCurrencies"
        class="transactions-sort-by-currency-from__select"
        :placeholder="select_the_debiting_currencies"
        clearable
        :value="selectedCurrencies[0]"
        @on-change="changeSelect"
    >
      <AtOption
          v-for="(currency, key) in current"
          :key="key"
          :value="currency.currency"
          :label="currency.currency"
      >
          <div class="transactions-sort-by-currency-from__option-container">
              <CurrencyImg
                      class="transactions-sort-by-currency-from__currency-img"
                      :currency="currency.currency"
              />
              <p class="transactions-sort-by-currency-from__option-text">{{ currency.currency }}</p>
          </div>
      </AtOption>
    </AtSelect>
  </div>
</template>

<script>

import {mapState, mapGetters, mapActions} from "vuex";

import AtSelect from 'at-ui/src/components/select';
import AtOption from 'at-ui/src/components/option';
import CurrencyImg from "../../elements/CurrencyImg";

export default {
    name: 'SortByCurrencyFrom',
    components: {
        AtSelect,
        AtOption,
        CurrencyImg,
    },
    data() {
        return {
            selectedCurrencies: [],
        };
    },
    computed: {
        ...mapState('app', [
            'currencies',
        ]),
        ...mapState('historyAddresses', ['type', 'currentNetwork']),
        ...mapGetters('app', [
            'hasCurrencies',
        ]),
        select_the_debiting_currencies() {
            return this.$t('transactions.select_the_debiting_currencies');
        },
        sortCurrencies() {
            return this.currencies.filter(el => el.isFiat === false);
        },

        current() {
            return this.currentNetwork.length ? this.currentNetwork : this.currencies;
        },
    },
    beforeMount() {
        this.setCurrenciesFromUrl();
    },
    methods: {
        ...mapActions('historyAddresses', [
            'addressTransactions',
        ]),
        setCurrenciesFromUrl() {
            const currenciesFromUrl = this.$route.query.currencyId;

            if (!currenciesFromUrl) {
                return false;
            }

            this.selectedCurrencies = currenciesFromUrl.split(',');
        },
        changeSelect(values) {
            const {
                $route,
                $router,
                addressTransactions,
            } = this;
            const val = values ? [values] : [];
            addressTransactions({
                route: $route,
                router: $router,
                currencyId: val,
                excludeParams: ['page'],
                type: this.type,
            });
        },
    },
};

</script>

<style lang="scss" scoped>
.transactions-sort-by-currency-from {
  &__title {
    margin-bottom: 8px;
    font-size: var(--font-size-text-main);
    font-family: var(--font-family);
    line-height: var(--line-height);
    color: var(--primary-font-color);
  }

  &__option-container {
    display: flex;
    gap: 15px;
    align-items: center;
  }

  &__currency-img {
    width: 30px;
    height: 30px;
  }

  &__option-text {
    color: var(--primary-font-color);
  }

  &__select ::v-deep .at-select {
    background: var(--secondary-color);
    box-sizing: border-box;
  }

  ::v-deep .at-select__arrow {
    font-size: 24px;
    color: #8F949A;
    margin-top: 0;
    top: calc(50% - 12px);
  }

  ::v-deep .at-select__clear {
    font-size: 24px;
    color: #8F949A;
    margin-top: 0;
    top: calc(50% - 12px);
  }

  &__select::v-deep .at-select__selection {
    border-radius: 12px;
    min-height: 46px;
    display: flex;
    padding-left: 20px;
    align-items: center;
    box-shadow: inset 0px 4px 20px rgba(0, 0, 0, 0.03);
    flex-wrap: wrap;
    border: 1px solid var(--border-color);
    background: var(--secondary-color);
    color: var(--primary-font-color);
  }

  &::v-deep .at-select__dropdown {
    border: 1px solid var(--border-color);
    background: var(--bg-select);
  }

  ::v-deep .at-select__option--selected {
    background: var(--hover-color-select);
  }

  ::v-deep .at-select__dropdown .at-select__option {
    font-family: var(--font-family);
    font-size: var(--font-size-text-main);
    line-height: var(--line-height);
    color: var(--primary-font-color);

    &:hover {
      background: var(--hover-color-select);
    }
  }

  ::v-deep .at-select__placeholder {
    font-family: var(--font-family);
    font-size: var(--font-size-text-main);
    line-height: var(--line-height);
  }

  ::v-deep .at-select__selection {
    font-family: var(--font-family);
    font-size: var(--font-size-text-main);
    line-height: var(--line-height);
    color: var(--primary-font-color);
  }

}


</style>